import { Button, Space, Typography } from 'antd';
import React from 'react';
import InsituTemplate from '../../../../../assets/validation/Template_InSitu.csv';
import UploadInsitu from './UploadInsitu';

import styles from '../../../../features/ResultPanel/Style/ValidationPanel.module.scss';

const { Title, Text } = Typography;

interface NoInSituDataComponentProps {
  name: string;
  longitude: number;
  latitude: number;
  source: string;
  onChangeToMatchInSitu: () => void;
  uploadRef: React.MutableRefObject<any>;
  onUploadComplete: () => void;
  disabledUpload: boolean;
}

const NoInSituData: React.FC<NoInSituDataComponentProps> = ({
  name,
  longitude,
  latitude,
  source,
  onChangeToMatchInSitu,
  onUploadComplete,
  uploadRef,
  disabledUpload,
}) => {
  return (
    <div className={styles.noInSituData}>
      <Title
        level={4}
        className={styles.noInsituTitle}
        id='Validation-no-in-situ-available'
      >
        There is no in situ data available at this point
      </Title>

      <div className={styles.noInsituButtons}>
        <Button
          id='Validation-NoInsituAvailable-Change_location_button'
          type='primary'
          onClick={onChangeToMatchInSitu}
          style={{ borderRadius: 8, flex: 1 }}
        >
          Change location to closest in situ station
        </Button>
        <UploadInsitu
          ref={uploadRef}
          onUploadComplete={onUploadComplete}
          disabled={disabledUpload}
        />
      </div>

      <div className={styles.noInsituInfo}>
        <div className={styles.noInsituClosestInfo}>
          <Text strong underline id='No-in-situ-available-title'>
            Closest in situ station:
          </Text>
          <Text>
            <Text strong>Name:</Text>{' '}
            <Text data-testid='In-situ-closest-station__name'>{name}</Text>
          </Text>
          <Text>
            <Text strong>Lon. [°E]:</Text>{' '}
            <Text data-testid='In-situ-closest-station__longitude'>
              {longitude}
            </Text>
          </Text>
          <Text>
            <Text strong>Lat. [°N]:</Text>
            <Text data-testid='In-situ-closest-station__latitude'>
              {' '}
              {latitude}
            </Text>
          </Text>
          <Text>
            <Text strong>Source:</Text>{' '}
            <Text data-testid='In-situ-closest-station__source'>{source}</Text>
          </Text>
        </div>
        <Space
          style={{ width: 232, lineHeight: '1.5' }}
          align='start'
          direction='vertical'
        >
          <Text>
            Download the in situ{' '}
            <Button
              type='link'
              style={{ padding: 0 }}
              href={InsituTemplate}
              download='Template_InSitu.csv'
              target='_blank'
              rel='noreferrer'
              data-testid='In-situ-download-template'
            >
              .csv
            </Button>{' '}
            template file, fill it in and upload it.
          </Text>
        </Space>
      </div>
    </div>
  );
};

export default NoInSituData;
